import type { TMessages } from '@/types/TMessages'

export const messages = {
  more: 'Подробнее',
} as const satisfies TMessages
